import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-24 bg-brand-900 text-white relative overflow-hidden" data-id="element-34">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&fit=crop&fm=webp&w=1280&q=60')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-35"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-37">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 leading-tight" data-id="element-38">
            Tu hígado no puede esperar. <br className="hidden md:block" data-id="element-39" />
            <span className="text-brand-300" data-id="element-40">Vos tampoco deberías.</span>
          </h2>

          <p className="text-xl text-brand-100 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-41">
            Llevate la guía completa, el menú de 7 días y los 6 bonos exclusivos
            por un único pago de $14.999 ARS.
          </p>

          <Button size="xl" variant="secondary" className="shadow-2xl shadow-accent-500/30 text-lg px-12" data-id="element-42">
            Sí, quiero cuidar mi hígado hoy
          </Button>

          <p className="mt-6 text-brand-300 text-sm font-medium" data-id="element-43">
            Acceso inmediato tras el pago • Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}